import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import axios from "axios";
import { PageLoader } from "@/components/MoneyMachineLoader";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DemoLogin = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    const loginDemo = async (retries = 3, delay = 800) => {
      for (let i = 0; i < retries; i++) {
        try {
          const resp = await axios.post(`${API_URL}/api/demo/login`, {}, { withCredentials: true });
          setUser(resp.data);
          navigate("/dashboard", { replace: true, state: { user: resp.data } });
          return;
        } catch (e) {
          console.error(`Demo login attempt ${i + 1} failed:`, e);
          if (i < retries - 1) {
            await new Promise((r) => setTimeout(r, delay));
          }
        }
      }
      setError("Failed to start demo. Please try again.");
    };
    loginDemo();
  }, [navigate, setUser]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-background gap-4">
        <p className="text-muted-foreground">{error}</p>
        <button
          className="text-primary underline text-sm"
          onClick={() => { setError(null); attempted.current = false; }}
        >
          Retry
        </button>
      </div>
    );
  }

  return <PageLoader />;
};

export default DemoLogin;
